import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d35d075a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-footer-sections" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "hd-c-hub-footer-sections__panel" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_panel_module = _resolveComponent("panel-module")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.endpointId,
        class: _normalizeClass([
				`hd-c-hub-footer-sections__item`,
				{ 'is-active': section.endpointId === _ctx.panel }
			]),
        onClick: ($event: any) => (_ctx.processPanel((() => {
				return (_ctx.panel !== section.endpointId) ? section.endpointId : null
			})()))
      }, [
        _createVNode(_component_lyra_asset, {
          class: "hd-c-hub-footer-sections__title",
          "asset-key": `section-${section.endpointId}-title`
        }, null, 8, ["asset-key"]),
        _createVNode(_component_base_image_svg, {
          source: require('!html-loader!@/ui/assets/icons/chevron-up.svg')
        }, null, 8, ["source"])
      ], 10, _hoisted_2))
    }), 128)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.panel && _ctx.sections.map((_) => _.endpointId).includes(_ctx.panel))
          ? (_openBlock(), _createBlock(_component_panel_module, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayMenuEndpoints(_ctx.panel), (endpoint) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: endpoint.endpointId,
                      class: _normalizeClass([
							`hd-c-hub-footer-sections__panel-item`,
						]),
                      onClick: ($event: any) => (_ctx.navigateTo(endpoint.endpointId, _ctx.panel))
                    }, [
                      _createVNode(_component_lyra_asset, {
                        class: "hd-c-hub-footer-sections__panel-title",
                        "asset-key": `bottom-nav-subsection-${endpoint.endpointId}`
                      }, null, 8, ["asset-key"])
                    ], 8, _hoisted_4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSubsections(_ctx.panel), (subsection) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: subsection.endpointId,
                      class: _normalizeClass([
							`hd-c-hub-footer-sections__panel-item`,
						]),
                      onClick: ($event: any) => (_ctx.navigateToEndpoint(subsection.endpointId, _ctx.panel))
                    }, [
                      _createVNode(_component_lyra_asset, {
                        class: "hd-c-hub-footer-sections__panel-title",
                        "asset-key": `bottom-nav-subsection-${subsection.endpointId}`
                      }, null, 8, ["asset-key"])
                    ], 8, _hoisted_5))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}